import _ from 'lodash'
import fp from 'lodash/fp'
import {
  SET_CUSTOMER,
  SET_CUSTOMERS,
  SET_PAGINATED_FEEDBACK,
  SET_CUSTOMER_FEEDBACK,
  SET_CUSTOMER_NPS,
  SET_CUSTOMER_RATER,
  SET_PAGINATED_CUSTOMERS,
} from '../../actions'

const customersReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_CUSTOMER: {
      return _.merge({}, state, { [action.customer.email]: action.customer })
    }
    case SET_PAGINATED_CUSTOMERS:
    case SET_CUSTOMERS: {
      return _.merge(
        {},
        state,
        _.keyBy(action.customers, (customer) => customer.email)
      )
    }
    case SET_PAGINATED_FEEDBACK: {
      return _.merge(
        {},
        state,
        _.flow([
          fp.map((feedback) => ({
            email: feedback.client_email,
            name: feedback.client_name,
          })),
          fp.keyBy((feedback) => feedback.email),
        ])(action.feedback)
      )
    }
    case SET_CUSTOMER_FEEDBACK: {
      return _.merge({}, state, {
        [action.customerEmail]: {
          feedback: action.feedback,
        },
      })
    }
    case SET_CUSTOMER_RATER: {
      return _.merge({}, state, { [action.email]: { rawRater: action.data } })
    }
    case SET_CUSTOMER_NPS: {
      return _.merge({}, state, { [action.email]: { rawNPS: action.data } })
    }
    default:
      return state
  }
}

export default customersReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/customers.js